import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-red.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-new.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_truck-booking-black.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_o_boat.svg'
import _imports_4 from '@/app/ui/assets/svg/ics_o_plane-booking-black.svg'


const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "w-4 h-4",
  alt: "Chevron Up"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  class: "w-4 h-4",
  alt: "Chevron Down"
}
const _hoisted_5 = {
  key: 1,
  class: "\n          absolute right-0 mt-2 bg-white border border-gray-lp-900 \n          rounded-xl shadow-lg z-50 py-2 px-3 flex flex-col gap-2 \n          text-black-lp-100\n        ",
  style: {"width":"180px"}
}
const _hoisted_6 = { class: "flex flex-col font-normal text-sm" }
const _hoisted_7 = {
  key: 0,
  src: _imports_2,
  class: "w-5 h-5",
  alt: "Truck"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_3,
  class: "w-5 h-5",
  alt: "Boat"
}
const _hoisted_9 = {
  key: 2,
  src: _imports_4,
  class: "w-5 h-5",
  alt: "Plane"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      (_ctx.getCargoTypeOptions.length)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: ["\n          w-36 font-semibold text-xs \n          justify-center py-3 rounded-lg \n          border flex items-center gap-2\n        ", 
          `${
            _ctx.isOpenModa
              ? 'border-red-lp-2400 text-red-lp-2400 cursor-pointer'
              : _ctx.disabledChangeTransport
              ? 'border-gray-lp-600 text-gray-lp-600 cursor-not-allowed'
              : 'border-gray-lp-600 text-black-lp-100 cursor-pointer'
          }`
        ],
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleModa && _ctx.toggleModa(...args))),
            disabled: _ctx.disabledChangeTransport
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.create.common.othersMode")) + " ", 1),
            (_ctx.isOpenModa)
              ? (_openBlock(), _createBlock("img", _hoisted_3))
              : (_openBlock(), _createBlock("img", _hoisted_4))
          ], 10, ["disabled"]))
        : _createCommentVNode("", true),
      (_ctx.isOpenModa)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCargoTypeOptions, (cargoType) => {
                return (_openBlock(), _createBlock("span", {
                  class: "py-2 cursor-pointer flex items-center gap-2",
                  key: cargoType.value,
                  onClick: ($event: any) => (_ctx.handleSelectModa(cargoType.value))
                }, [
                  (cargoType.value === 'truck')
                    ? (_openBlock(), _createBlock("img", _hoisted_7))
                    : (cargoType.value === 'ship')
                      ? (_openBlock(), _createBlock("img", _hoisted_8))
                      : (cargoType.value === 'plane')
                        ? (_openBlock(), _createBlock("img", _hoisted_9))
                        : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(cargoType.label), 1)
                ], 8, ["onClick"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_click_outside, () => (_ctx.isOpenModa = false)]
    ]),
    (_ctx.showSelectSchedule)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          "data-testid": "cargo-v2-edit-header-button-select-schedule",
          class: ["\n        w-36 font-semibold text-xs\n        justify-center cursor-pointer py-3 rounded-lg\n        border flex items-center gap-2\n      ", 
        `${
          _ctx.disabledSelectSchedule
            ? 'border-gray-lp-600 text-gray-lp-600 cursor-not-allowed'
            : 'border-red-lp-2400 text-red-lp-2400 cursor-pointer'
        }`
      ],
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSelectSchedule && _ctx.handleSelectSchedule(...args))),
          disabled: _ctx.disabledSelectSchedule
        }, _toDisplayString(_ctx.$t("cargoV2.create.common.selectSchedule")), 11, ["disabled"]))
      : _createCommentVNode("", true),
    _createVNode("button", {
      "data-testid": "cargo-v2-edit-header-button-booking",
      class: ["w-36 text-white rounded-lg font-semibold text-xs py-3", 
        `${
          _ctx.disabledBooking
            ? 'bg-gray-lp-600 cursor-not-allowed'
            : 'bg-red-lp-2400 cursor-pointer'
        }`
      ],
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleBooking && _ctx.handleBooking(...args))),
      disabled: _ctx.disabledBooking
    }, _toDisplayString(_ctx.$t("cargoV2.create.common.booking")), 11, ["disabled"])
  ]))
}